/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadAssignmentRole } from './LeadAssignmentRole';
import {
    LeadAssignmentRoleFromJSON,
    LeadAssignmentRoleFromJSONTyped,
    LeadAssignmentRoleToJSON,
} from './LeadAssignmentRole';

/**
 * 
 * @export
 * @interface LeadAssignmentSummary
 */
export interface LeadAssignmentSummary {
    /**
     * 
     * @type {string}
     * @memberof LeadAssignmentSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadAssignmentSummary
     */
    user_id: string;
    /**
     * 
     * @type {LeadAssignmentRole}
     * @memberof LeadAssignmentSummary
     */
    role: LeadAssignmentRole;
}

/**
 * Check if a given object implements the LeadAssignmentSummary interface.
 */
export function instanceOfLeadAssignmentSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "role" in value;

    return isInstance;
}

export function LeadAssignmentSummaryFromJSON(json: any): LeadAssignmentSummary {
    return LeadAssignmentSummaryFromJSONTyped(json, false);
}

export function LeadAssignmentSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadAssignmentSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user_id': json['user_id'],
        'role': LeadAssignmentRoleFromJSON(json['role']),
    };
}

export function LeadAssignmentSummaryToJSON(value?: LeadAssignmentSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user_id': value.user_id,
        'role': LeadAssignmentRoleToJSON(value.role),
    };
}

